// @flow
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import Input from '../Input';
import Button from '../Button';
import { Wrapper } from './style';
import history from '../../history';

import { makeSearch, setCriteria } from '../../actions/search';
import { resetFacetState } from '../../actions/ui';

import type { SetCriteria } from '../../types/Criteria';
import { FormattedMessage } from 'react-intl';
import { formatMessage } from '../../CurrentLocale';

type Props = {
  query: string,
  adv: string,
  makeSearch: () => void,
  resetFacetState: () => void,
  setCriteria: SetCriteria => void
};

type State = {
  query: string
};

class SearchBar extends Component<Props, State> {
  state = {
    query: ''
  };

  goToAdvancedSearch = () => {
    history.replace(`/${history.location.search}`);
  };

  runSearch = () => {
    const { query } = this.state;

    this.props.setCriteria({ query });

    this.props.resetFacetState();

    this.props.makeSearch();
  };

  handleKeyPress = e => {
    const keyCode = e.keyCode || e.which;
    if (keyCode === 13) {
      this.runSearch();
    }
  };

  handleChangeQuery = ({ target: { value: query } }) => {
    this.setState({ query });
  };

  render() {
    const { query, adv } = this.props;

    const supp = adv
      ? ` ${formatMessage({ id: 'conditions.AND' })} ${adv}`
      : '';

    const keyButton = adv
      ? 'searchBar.advanced_search'
      : 'searchBar.update_search';

    return (
      <Wrapper className="root-container">
        <div className="separator">
          {' '}
          <FormattedMessage id="searchBar.your_search" />
        </div>

        <div className="bar-zone">
          <Input
            className="input"
            defaultValue={`${query}${supp}`}
            disabled={!!adv}
            onChange={this.handleChangeQuery}
            onKeyPress={this.handleKeyPress}
          />

          <div className="buttonZone">
            <Button
              border={!adv}
              onClick={() =>
                !adv ? this.runSearch() : this.goToAdvancedSearch()
              }
            >
              <FormattedMessage id={keyButton} />
            </Button>

            {!adv && (
              <div className="buttonZone">
                <Button border={false} onClick={this.goToAdvancedSearch}>
                  <FormattedMessage id="searchBar.advanced_search" />
                </Button>
              </div>
            )}
          </div>
        </div>
      </Wrapper>
    );
  }
}

const mapStateToProps = ({ search }) => ({
  adv: search.adv,
  query: search.query
});

export default withRouter(
  connect(
    mapStateToProps,
    dispatch => {
      return {
        setCriteria: args => dispatch(setCriteria(args)),
        resetFacetState: () => dispatch(resetFacetState()),
        makeSearch: () => dispatch(makeSearch())
      };
    }
  )(SearchBar)
);



// WEBPACK FOOTER //
// ./src/components/SearchBar/index.js